import React from 'react'
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const style = {
   position: 'absolute',
   top: '50%',
   left: '50%',
  transform: 'translate(-50%, -50%)',
  width:300,
  //height:150,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderColor: "green",
  verticalAlign: "middle",
  display: "table-cell",
  boxShadow: 20,
  p: 2, //padding 설정
};
function IpgoSaveMessage(props) {
  return (
      <div>
        <Modal open={props.esave}>
          <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{color: "blue"}}>
            -입고등록-
          </Typography>
          <Typography id="modal-modal-description" >
            입고등록 [저장][수정][삭제]가 정상적으로 <br/> 처리되었습니다.<br/><div style={{textAlign:'center', fontSize:'20px', color:'blue'}}>[Save Ok]</div>
          </Typography>
              <Button onClick={() => { props.setEsave(false)}} 
                  variant="outlined"
                  style={{
                    background:'#388e3c',
                    color:'white',
                    height: "30px",
                    width: 90,
                    marginTop: "10px",
                    float: "right",
                  }}>닫기</Button>
          </Box>
        </Modal>
  
      </div>
  )
}

export default IpgoSaveMessage